export enum SdkType {
  DE = 'de',
  EU = 'eu',
}
